import { detect } from 'detect-browser'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { PoliciesType } from '../../@types/aboutfishing'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import AgreeDetail from '../../pages/member/AgreeDetail'
import PhoneChange from '../../pages/member/phonechange'
import PhoneModify from '../../pages/member/PhoneModify'
import SignAgree from '../../pages/member/SignAgrees'
import SignInfo from '../../pages/member/signinfo'
import SignIntro from '../../pages/member/SignIntro'
import SignUpCompleted from '../../pages/member/SignUpCompleted'
import { useCommonContext } from '../provider/CommonProvider'
import KakaoAuth from '../../pages/member/KakaoAuth'
import Sign from '../../pages/member/sign'
// 이미지 경로
const imgURL = '/images'

interface PropsType {
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
}

/**
 * 모달 팝업 - 전체 화면
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

export default function LogInModal({ setLoggedIn }: PropsType) {
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요
  const [text, setText] = useState<string>('start')
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const [messageId, setMessageId] = useState<string>('')
  const [code, setCode] = useState<string>('')
  const [os, setOs] = useState<any>('')
  const [verificationCheckCode, setVerificationCheckCode] = useState<string>('')
  const [changeEmail, setChangeEmail] = useState<string>('') //변경이메일
  const [changePhone, setChangePhone] = useState<string>('') //변경 전 폰번호
  const [detailText, setDetailText] = useState<string>('')
  const [policy, setPolicy] = useState<PoliciesType[]>([])
  const [authType, setAuthType] = useState<string>('mobile')
  const [kakaoToken, setKakaoToken] = useState<string>('')
  const [kakaoUserData, setKakaoUserData] = useState<any>()
  const [email, setEmail] = useState<string>('')
  const { isLogin, setIsLogin } = useCommonContext()

  useEffect(() => {
    const browerOs = detect()
    setOs(browerOs?.os)
  }, [])

  useEffect(() => {
    const preventGoBack = () => {
      closeModal()
    }
    window.addEventListener('popstate', preventGoBack)
    return () => window.removeEventListener('popstate', preventGoBack)
  }, [])

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setIsLogin(false)
      setClosing(false)
    }, 280)
  }

  if (!isLogin) return null
  return (
    <ModalWrap style={{ zIndex: 40 }}>
      <ModalBox closing={closing}>
        {text === 'start' ? (
          <SignIntro
            closeModal={closeModal}
            setText={setText}
            setAuthType={setAuthType}
            setKakaoUserData={setKakaoUserData}
            setKakaoToken={setKakaoToken}
          ></SignIntro>
        ) : (
          <>
            <ModalHeader
              style={{
                padding: text !== 'agreeDetail' ? ' 0px 4px 0px 20px' : ' 0px 4px 0px 4px',
                height: '60px',
              }}
            >
              {text !== 'agreeDetail' ? null : (
                <button
                  className='btn_close'
                  onClick={() => {
                    setText('agree')
                  }}
                >
                  <img src={`${imgURL}/icon_back.svg`} alt='' />
                </button>
              )}
              {(text === 'login' || text === 'kakao') && (
                <button
                  onClick={() => {
                    setText('start')
                    setPhoneNumber('')
                    setMessageId('')
                    setCode('')
                    setEmail('')
                    setVerificationCheckCode('')
                  }}
                  style={{
                    width: '35px',
                    height: '60px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  <img src={`${imgURL}/icon_login_back.svg`} alt='' style={{ width: '9px', height: '18px' }} />
                </button>
              )}
              {text === 'signUpCompleted' || text === 'login' || text === 'kakao' ? null : (
                <>
                  <p></p>
                  <button
                    className='btn_close'
                    onClick={() => {
                      const confirm = window.confirm('회원가입을 종료 하시겠습니까?')
                      if (confirm) {
                        closeModal()
                        setTimeout(() => {
                          setText('start')
                        }, 280)
                      }
                    }}
                  >
                    <img src={`${imgURL}/icon_close.png`} alt='닫기' />
                  </button>
                </>
              )}
            </ModalHeader>
            {text === 'login' && (
              <Sign
                setText={setText}
                setPhoneNumber={setPhoneNumber}
                phoneNumber={phoneNumber}
                messageId={messageId}
                setMessageId={setMessageId}
                code={code}
                setCode={setCode}
                os={os}
                setEmail={setEmail}
                closeModal={closeModal}
                email={email}
                setVerificationCheckCode={setVerificationCheckCode}
              ></Sign>
            )}

            {text === 'kakao' && (
              <KakaoAuth
                setText={setText}
                setPhoneNumber={setPhoneNumber}
                phoneNumber={phoneNumber}
                messageId={messageId}
                setMessageId={setMessageId}
                code={code}
                setCode={setCode}
                os={os}
                setEmail={setEmail}
                closeModal={closeModal}
                email={email}
                setVerificationCheckCode={setVerificationCheckCode}
              ></KakaoAuth>
            )}
            {text === 'agree' && (
              <SignAgree
                setText={setText}
                setDetailText={setDetailText}
                setPolicy={setPolicy}
                policy={policy}
                authType={authType}
                kakaoToken={kakaoToken}
                kakaoUserData={kakaoUserData}
                email={email}
                phoneNumber={phoneNumber}
                verificationCheckCode={verificationCheckCode}
              ></SignAgree>
            )}
            {text === 'agreeDetail' && <AgreeDetail detailText={detailText}></AgreeDetail>}
            {text === 'signIn' && (
              <SignInfo
                phoneNumber={phoneNumber}
                os={os}
                verificationCheckCode={verificationCheckCode}
                setText={setText}
                policy={policy}
              ></SignInfo>
            )}

            {text === 'phonechange' && (
              <PhoneChange
                setChangeEmail={setChangeEmail}
                setChangePhone={setChangePhone}
                setText={setText}
              ></PhoneChange>
            )}
            {text === 'phonemodify' && (
              <PhoneModify
                setText={setText}
                changeEmail={changeEmail}
                changePhone={changePhone}
                closeModal={closeModal}
              ></PhoneModify>
            )}
            {text === 'signUpCompleted' && <SignUpCompleted closeModal={closeModal}></SignUpCompleted>}
          </>
        )}
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  )
}

interface typeProps {
  closing?: boolean
}

export const ModalBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 10;
`

export const ModalBox = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  height: 100%;
  background-color: var(--colWhite);
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: fixed;
  z-index: 30;
  display: flex;
  flex-direction: column;
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 4px 0 20px;
  align-items: center;
  & button.btn_close {
    width: 48px;
    height: 48px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 12px;
    img {
      width: 100%;
      height: 100%;
    }
  }
`

export const ModalBody = styled.div``

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`
